import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

// 轮播
import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, useSwiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Nav from '../components/Nav1';
import './index.scss';
import dalian1 from '@/assets/dalian1.png'
import dalian2 from '@/assets/dalian2.png'
import dalian3 from '@/assets/dalian3.png'
import left from '@/assets/swipe_left.png'
import right from '@/assets/swipe_right.png'

const SwiperButtonNext = ({ children }) => {
  const swiper = useSwiper();
  return (
    <span
      slot="container-start"
      onClick={() => swiper.slideNext()}
      className="swiper-button-prev"
      style={{
        right: "var(--swiper-navigation-sides-offset, 10px)",
        left: "auto",
      }}
    >
      <img className='swiper-btn' src={right} alt='' />
    </span>
  );
};

const SwiperButtonPrev = ({ children }) => {
  const swiper = useSwiper();
  return (
    <span
      onClick={() => swiper.slidePrev()}
      className="swiper-button-next"
      style={{
        left: "var(--swiper-navigation-sides-offset, 10px)",
        right: "auto",
      }}
      slot="container-start"
    >
      <img className='swiper-btn' src={left} alt='' />
  </span>
  );
};

function OfficeDL() {
  const { t } = useTranslation();
  const { lang: langInPath } = useParams();
  
  return (
    <div id='DLTop' className="office-page flex-col">
        {/* 菜单栏 */}
      <div className="news-menu-group">
        <Nav lang={langInPath} />
      </div>
      <div className="office-wrapper">
        <h1 className="office-title">{t('选择你喜欢的城市办公')}&nbsp;—&nbsp;{t('大连')}</h1>
        <div className="office-text-wrap">
          <div className="office-paragraph">
            {t('大连是一座依山傍海的城市，大连分公司就坐落在这样美丽城市的海边。地址位于辽宁省大连市高新园区万科创智中心C3号楼15楼1506室。')}
          </div>
          <div className="office-paragraph">
            {t('大连培养了众多优秀日语人才，因此我们将大连分公司作为我们的日语客服中心，承接客户售前&售后的客户线上问询或者电话咨询。')}
          </div>
          <div className="office-paragraph">
            {t('大连分公司拥有日本领导层的管理，和日本的培训专员。因此大连的日语客服更加了解日本文化，能够同理客户的需求，可以给日本客户提供日本标准的客服对应质量。')}
          </div>
          <div className="office-paragraph">
            {t('我们珍惜每一位客户，珍惜每一位员工，珍惜每一个来之不易的机会！所以你也珍惜这次的机会哦！')}
          </div>
        </div>
        <div className="office-group">
          <Swiper
            navigation={false}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Autoplay]}
            className="row-wrap mySwiper"
          >
            <SwiperButtonPrev />
            <SwiperButtonNext />
            <SwiperSlide style={{width: '100%', display: 'flex', justifyContent: 'center', height: 600}}>
              <img className="block_1" src={dalian1} alt='' />
            </SwiperSlide>
            <SwiperSlide style={{width: '100%', display: 'flex', justifyContent: 'center', height: 600}}>
              <img className="block_1" src={dalian2} alt='' />
            </SwiperSlide>
            <SwiperSlide style={{width: '100%', display: 'flex', justifyContent: 'center', height: 600}}>
              <img className="block_1" src={dalian3} alt='' />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>


    </div>
  );
}

export default OfficeDL;
